import styled from 'vue-styled-components';

import { COLORS } from '../../colors';
import { FONTS } from '../../constants';

export const Container = styled.div`
  width: 100%;
  font-size: 16px;
  overflow-x: auto;
  margin-bottom: 25px;

  table {
    margin: 0 auto auto;
    width: 100%;
    border-collapse: collapse;
    vertical-align: middle;
    text-align: left;
    color: ${COLORS.MAKO};
    font-family: ${FONTS.KNOCKOUT_32_FONT};
    border: 1px solid ${({ theme }) => theme.lightColor};
  }

  th {
    color: ${COLORS.WHITE};
    flex: 1;
    padding: 8px;
    background-color: ${({ theme }) => theme.mainColor};
    min-width: 100px;
  }

  tr {
    border-bottom: 1px solid ${({ theme }) => theme.lightColor};
    display: flex;
    flex-direction: row;
  }

  tr.highlighted {
    background-color: ${({ theme }) => theme.lightColor};
  }

  tr:not(.highlighted) td:first-child {
    opacity: 0;
    visibility: hidden;
  }

  td {
    flex: 1;
    padding: 8px;
  }
`;
